var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"Tmenu"},[_c('topMenu')],1),_c('div',{staticClass:"main"},[_c('router-view'),_c('div')],1),_c('div',{staticClass:"footer"},[_vm._v("V1.1")])])}
var staticRenderFns = []

export { render, staticRenderFns }